import { Injectable } from "@angular/core";

@Injectable()
export class PasswordConstants{
    RequiredLength = 8;
    RequireNonLetterOrDigit = true;
    RequireDigit = true;
    RequireLowercase = true;
    RequireUppercase = true;
}
